import { Component, HostListener, input, output } from '@angular/core';

@Component({
  selector: 'app-confirm-modal',
  imports: [],
  templateUrl: './confirm-modal.html',
})
export class ConfirmModalComponent {
  title = input<string>('Confirm');
  message = input<string>('Are you sure?');
  confirmLabel = input<string>('Delete');
  closed = output<void>();
  confirmed = output<void>();

  @HostListener('document:keydown.escape')
  onEsc(): void {
    this.closed.emit();
  }

  protected onBackdropClick(e: MouseEvent): void {
    if (e.target === e.currentTarget) this.closed.emit();
  }
}
